import * as yup from 'yup';


export const CreateOrganisationPersonValidationSchema = yup.object().shape({
    personalInfo: yup.object({
        firstName: yup.string().required('First name is required').max(100, 'First name must be less than 100 characters'),
        lastName: yup.string().required('Surname is required').max(100, 'Surname must be less than 100 characters'),
        idNumber: yup.string().max(128, 'ID number must be less than 128 characters'),
        employeeCode: yup.string()
        .when('idNumber', (idNumber, schema) => {
            return schema.test('employeeCode', 'Either Employee Code or ID number is required', function (employeeCode: string){
                if (idNumber){
                    return true
                }
                if (employeeCode){
                    return true;
                }
            })
        }).max(50, 'Employee code must be less than 50 characters'),
        gender: yup.number().required('Gender is required').typeError('Gender is required'),
        race: yup.number().required('Race is required').typeError('Race is required'),
        nationality: yup.number().nullable().transform((curr, orig) => (orig === '' ? 0 : curr)),
        isDisabled: yup.bool().nullable(),
        dateOfBirth: yup.date().nullable().default(null).transform((curr, orig) => orig === '' ? null : curr)
    }),
    employmentData: yup.object({
        siteName: yup.string().max(128, 'Site name must be less than 128 characters'),
        startDate: yup.date()
            .required('Start Date is required')
            .typeError('Start Date is not a valid date'),
        endDate: yup
            .date()
            .nullable()
            .transform((curr, orig) => (orig === '' ? null : curr))
            .when('startDate', (startDate, schema) => {
                return schema.test('endDate', 'End Date must be greater than Start Date', function (
                    endDate: any
                ) {
                    if (!endDate || !startDate) {
                        return true;
                    }
                    return endDate > startDate;
                });
            }),
        job: yup.string().required('Job Title is required').max(128, 'Job title must be less than 128 characters'),
        employmentType: yup.number().required('Employment Type is required').typeError('Employment Type is required'),
        occupation: yup.number().nullable().transform((curr, orig) => (orig === '' ? 0 : curr)),
        municipality: yup.number().nullable().transform((curr, orig) => (orig === '' ? 0 : curr)),
        province: yup.number().nullable().transform((curr, orig) => (orig === '' ? 0 : curr))
        }),
        
});



